import { render, staticRenderFns } from "./NInputView.vue?vue&type=template&id=49fe6d5c&scoped=true&"
import script from "./NInputView.vue?vue&type=script&lang=js&"
export * from "./NInputView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fe6d5c",
  null
  
)

export default component.exports